(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/utils.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/utils.js');
"use strict";


const CODE_LENGTH = 31;
const CODE_PART_LENGTHS = [5, 7, 3, 3, 9];
const ERRORS = {
  INVALID_CHARS: 'Tillåtna tecken: 0-9.',
  INVALID_PRODUCT_ID: 'Sifferserien är felaktig.',
  MESSAGE_MAX: 'För lång sifferserie.',
  MESSAGE_MIN: 'För kort sifferserie.',
  MESSAGE_MIN_MAX: 'Sifferserien ska bestå av 27 tecken.',
  REQUIRED_ERROR: 'Du måste ange en sifferserie.'
};
setGlobal('svs.ticketsValidateManual.utils', {
  constants: {
    CODE_LENGTH,
    CODE_PART_LENGTHS,
    ERRORS
  },
  validateTicketId: value => {
    let errorMessage = '';
    let isValid = true;
    try {
      svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(value);
    } catch (error) {
      isValid = false;
      errorMessage = ERRORS[error.code] || ERRORS.INVALID_PRODUCT_ID;
    }
    return {
      errorMessage,
      isValid
    };
  },
  validateProductId: value => {
    let errorMessage = '';
    let isValid = true;
    try {
      svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(value, false);
    } catch (error) {
      isValid = false;
      errorMessage = ERRORS[error.code] || ERRORS.INVALID_PRODUCT_ID;
    }
    return {
      errorMessage,
      isValid
    };
  }
});

 })(window);